export let CurrentActiveTests = [];
let ActiveTests = [];//Cache
export let ActiveTestCallbacks = {};//Add your callbacks here
let ActiveTestFuncs = {};//Dont use

export const getActiveTests = () => {
  return [...CurrentActiveTests];
}

export const checkTests = () => {
  let nowActive = getActiveTests();
  let lastActive  = [...ActiveTests];
  ActiveTests = nowActive;

  let notActive = lastActive.filter(x => !ActiveTests.includes(x));

  let bod = $(document.body);

  notActive.forEach(na => {
    if(!lastActive.includes(na)) return;
    // console.log(`Deactivating ${na}`);
    bod.removeClass(`is-split-${na}`);
    if(ActiveTestFuncs[na]) ActiveTestFuncs[na][1]();
  });
  
  ActiveTests.forEach(at => {
    if(lastActive.includes(at)) return;
    // console.log(`Activating ${at}`);
    bod.addClass(`is-split-${at}`);
    if(ActiveTestFuncs[at]) ActiveTestFuncs[at][0]();
  });
}

$(document).ready(() => {
  setInterval(() => checkTests(), 500);
  Object.keys(ActiveTestCallbacks).forEach(k => {
    ActiveTestFuncs[k] = ActiveTestCallbacks[k]();
  })
});


export const onSplit = (split) => {
  // console.log('Splitting on', split);
  CurrentActiveTests.push(split);
};

export const offSplit = (split) => {
  // console.log('Splitting off', split);
  CurrentActiveTests = CurrentActiveTests.filter(f => f != split);
};

window.onSplit = document.onSplit = onSplit;
window.offSplit = document.offSplit = offSplit;